import { ApiGet } from "../../libs/helper";
import { IApiResponse } from "../type-interface";

export const FecthAllheader = async (queryString: String): Promise<IApiResponse> => {
    const response = await ApiGet(`/masterdata/bank${queryString}`);
    return response;
}